import React from 'react';
import Close from 'svg/close';

/**
 * Terms
 *
 * Legal page
 */
const Terms = (props) => {
  const close = props.closeAction;

  return (
    <article className='Main-overlay Legal'>
      {/*Actions to control the Terms*/}
      <button
        title='Close'
        className='button button--outline button__close'
        onClick={close}
      >
        <Close className='Legal__icon Legal__icon-close' title='Close' />
      </button>
      <section className='Legal__text'>
        <p className='legal__paragraph'>Lorem, ipsum dolor, sit amet consectetur adipisicing elit. Distinctio architecto sint laudantium harum ipsum possimus officiis dolor, accusamus inventore in excepturi, recusandae amet perferendis rerum ipsam! Tenetur, accusamus. Doloremque, cupiditate.</p>
      </section>
    </article>
  );
};

export default Terms;

